import React from 'react'
import styles from './index.scss'
import { Popup } from 'antd-mobile'
import classnames from 'classnames'

interface IDpPopupProps {
  closeOnMaskClick?: boolean
  visible?: boolean
  bodyStyle?: React.CSSProperties
  popupBodyStyles?: React.CSSProperties
  containerStyles?: React.CSSProperties
  footerStyles?: React.CSSProperties
  headerStyle?: React.CSSProperties
  titleStyle?: React.CSSProperties
  onClose?: Function
  onConfirm?: Function
  onMaskClick?: Function
  children?: React.ReactNode
  footer?: React.ReactNode | string
  title?: React.ReactNode | string
  hiddenClose?: boolean
  pickerHeader?: {
    title?: string
  }
  popupProps?: Record<string, any>
  cancelText?: string
  okText?: string
  type?: string
  allowHeaderClose?: true
  className?: any
  containerClassName?: any
  footerClassName?: any
  headerClassName?: any
}

const Close = (props: any) => {
  return (
    <img
      className={styles['dp-BusinessPopup--close']}
      src={require('./assets/icon_close.png')}
      onClick={() => props?.onClose?.()}
      alt="关闭"
    />
  )
}
const Header = (props: IDpPopupProps) => {
  return (
    <header className={classnames([styles['dp-BusinessPopup--header'], 'dp-BusinessPopup--header'], props?.headerClassName)}  style={props?.headerStyle}>
      <div className={styles["dp-BusinessPopup--header--title"]} style={props?.titleStyle}>
        {props?.title}
        {props?.children}
      </div>
    </header>
  )
}

const PickerHeader = (props: IDpPopupProps) => {
  const { allowHeaderClose = true } = props
  return (
    <header className={classnames([styles['dp-BusinessPopup--header-picker'], 'dp-BusinessPopup--header-picker'], props?.containerClassName)}
      style={props?.headerStyle}>
      {
        props?.onClose && allowHeaderClose &&
          <div className={styles["dp-BusinessPopup--header-picker--cancel"]} onClick={() => props?.onClose?.()}>
            {props?.cancelText || lang['取消']}
          </div>
      }
      <div className={styles["dp-BusinessPopup--header-picker--title"]} style={props?.titleStyle}>
        {props?.title || lang['请选择']}
      </div>
      {
        props?.onConfirm &&
          <div className={styles["dp-BusinessPopup--header-picker--confirm"]} onClick={() => props?.onConfirm?.()}>
            {props?.okText || lang['确认']}
          </div>
      }
    </header>
  )
}

const DpBusinessPopup = (props: IDpPopupProps) => {
  return (
    <Popup
      {...props?.popupProps}
      visible={props?.visible}
      onMaskClick={() => props?.closeOnMaskClick && props?.onClose?.()}
      bodyStyle={{ borderRadius: '16px 16px 0px 0px', overflow: 'hidden', ...props?.bodyStyle }}
    >
      <div className={classnames([styles['dp-BusinessPopup'], 'dp-BusinessPopup'], props?.className)} style={{ minHeight: '50vh', maxHeight: '90vh',...props?.popupBodyStyles }}>
        {
          props?.type === 'picker' ?
            <PickerHeader {...props} />
            :
            props?.title && <Header headerClassName={props?.headerClassName} title={props?.title} headerStyle={props?.headerStyle} titleStyle={props?.titleStyle}  />
        }
        {props?.type !== 'picker' && <Close onClose={() => props?.onClose?.()} /> }
        <main
          className={classnames([styles['dp-BusinessPopup--container'], 'dp-BusinessPopup--container'], props?.containerClassName)}
          style={props?.containerStyles}
        >
          {props?.children}
        </main>
        {props?.footer && <footer className={classnames([styles['dp-BusinessPopup--footer'], 'dp-BusinessPopup--footer'], props?.footerClassName)} style={props?.footerStyles}> {props?.footer}</footer>}
      </div>
    </Popup>
  )
}
DpBusinessPopup.Header = Header
DpBusinessPopup.PickerHeader = PickerHeader
DpBusinessPopup.Close = Close
export default DpBusinessPopup;
